import React from 'react'

import { Icon, Discount, Dollar } from '@cgtrader/triangle-ui/dist/src/ssr-index'

const getSubscriptionCheckbox = (translate) => ({
  value: 'with_subscription',
  label: (
    <span className="filter-wrapper__option--with-icon">
      <span>{translate('search_page.filters.price.with_subscription')}</span>
      <Icon notSpaced svgComponent={Dollar} color="primary" size="small" />
    </span>
  ),
})

export const getPricingCheckboxFiltersConfig = (translate, withSubscriptionCheckbox) => [{
  label: '',
  filters: [
    {
      value: 'on_sale',
      label: (
        <span className="filter-wrapper__option--with-icon">
          <span>{translate('search_page.filters.price.on_sale')}</span>
          <Icon notSpaced svgComponent={Discount} color="primary" size="small" />
        </span>
      ),
    },
    ...(withSubscriptionCheckbox ? [getSubscriptionCheckbox(translate)] : []),
  ],
}]
